import React from 'react';
import { useTranslation } from 'react-i18next';
import MemberOnlyOverlay from '../components/MemberOnlyOverlay';
import SEO from '../components/SEO';

const Conferences = () => {
  const { t } = useTranslation();

  return (
    <MemberOnlyOverlay previewTitle="Conferences">
      <div data-testid="conferences-page" style={{ maxWidth: '800px', margin: '0 auto' }}>
        <SEO path="/conferences" title="AFHOS Conferences" description="Join AFHOS conferences, workshops, and webinars connecting researchers, clinicians, and policymakers working to combat cardiovascular disease across Africa." />
        <div className="page-header">
          <p className="overline">{t('conferences.overline')}</p>
          <h1 data-testid="conferences-title">{t('conferences.title')}</h1>
          <p>{t('conferences.subtitle')}</p>
        </div>

        <div className="content-section">
          <h2>{t('conferences.annualTitle')}</h2>
          <p>{t('conferences.annualDesc')}</p>
        </div>

        <div className="grid-3">
          <div className="card">
            <p className="overline">Feature</p>
            <h4>{t('conferences.sessions')}</h4>
            <p style={{ color: 'var(--muted)', fontSize: '0.9rem' }}>{t('conferences.sessionsDesc')}</p>
          </div>
          <div className="card">
            <p className="overline">Feature</p>
            <h4>{t('conferences.workshops')}</h4>
            <p style={{ color: 'var(--muted)', fontSize: '0.9rem' }}>{t('conferences.workshopsDesc')}</p>
          </div>
          <div className="card">
            <p className="overline">Feature</p>
            <h4>{t('conferences.policy')}</h4>
            <p style={{ color: 'var(--muted)', fontSize: '0.9rem' }}>{t('conferences.policyDesc')}</p>
          </div>
        </div>

        <div className="content-section">
          <h2>{t('conferences.pastTitle')}</h2>
          <p>{t('conferences.pastDesc')}</p>
        </div>

        <div className="content-section">
          <p style={{ textAlign: 'center', padding: '1.5rem', background: 'var(--brand-light)', borderRadius: 'var(--radius)' }}>
            <strong>{t('conferences.stayUpdated')}</strong> <a href="/events">{t('nav.events')}</a>
          </p>
        </div>
      </div>
    </MemberOnlyOverlay>
  );
};

export default Conferences;
